module.exports = __webpack_public_path__ + "static/media/Annamalai_University_logo.bed28273.png";